export const SITE = {
  name: '吃瓜网',
  subName: '瓜田观察站',
  domain: 'https://pnymf.cn',
  slogan: '把热闹，看成门道',
  description:
    '吃瓜网是简体中文娱乐热点与网络文化观察站，围绕娱乐话题、热剧综艺、网络热梗与围观方法，提供有信息、有分析、有边界感的阅读内容，畅读全文，免费无限制浏览。',
  email: 'hello@chigua-wang.com',
  keywords: '吃瓜网,娱乐热点,网络热梗,热剧综,吃瓜文化,理性围观',
  nav: [
    { label: '首页', path: '/' },
    { label: '娱乐热点', path: '/category/yule-redian' },
    { label: '热剧综', path: '/category/reju-zong' },
    { label: '网络热梗', path: '/category/wangluo-regeng' },
    { label: '瓜圈观察', path: '/category/guquan-guancha' },
    { label: '关于我们', path: '/about' },
  ],
};

export const FOOTER_LINKS = [
  {
    title: '内容栏目',
    links: [
      { label: '娱乐热点', path: '/category/yule-redian' },
      { label: '热剧综', path: '/category/reju-zong' },
      { label: '网络热梗', path: '/category/wangluo-regeng' },
      { label: '瓜圈观察', path: '/category/guquan-guancha' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '常见问题', path: '/faq' },
      { label: '联系我们', path: '/contact' },
      { label: '站内搜索', path: '/search' },
    ],
  },
];